/**
 * @nubeteck/formeck (0.19.5)
 * Copyright (c) Nubeteck, SRL.
 */
import { j as d } from "../../../chunks/jsx-runtime.BwWtxLpl.js";
import o from "react";
import { isEmpty as E } from "radash";
import { b as O } from "../../../chunks/currency-utils.DnRSwher.js";
import { d as R } from "../../../chunks/index.esm.eyITaPoj.js";
import { InputNumber as k } from "@nubeteck/components";
import w from "../../form-item/form-item.js";
import B from "../../../hooks/useFormCurrency.js";
import { useFormeckConfig as T } from "../../../contexts/formeck-config/formeck-config.js";
import "../../../contexts/stepper/stepper.js";
const V = ({
  min: m,
  max: s,
  name: c,
  help: y,
  label: b,
  rules: u,
  onBlur: p,
  suffix: x,
  prefix: g,
  onFocus: a,
  tooltip: S,
  onChange: i,
  defaultValue: h,
  disabledInput: j,
  renderFormItem: F = !0,
  formatMode: t = "formatted",
  ...e
}) => {
  const { currencySymbol: I } = B(), { inputSize: $, decimalScale: l } = T(), { field: n } = R({
    name: c,
    rules: u,
    defaultValue: h,
    disabled: e.disabled
  }), [C, f] = o.useState(!1), [N, q] = o.useMemo(() => t === "percentage" ? [0, 100] : [m, s], [t, s, m]), z = o.useMemo(() => Math.max(
    0,
    Math.min((e.precision || l) ?? 0, 20)
  ), [l, e.precision]);
  return /* @__PURE__ */ d.jsx(
    w,
    {
      name: c,
      help: y,
      label: b,
      tooltip: S,
      noStyle: !F,
      required: !!u?.required,
      children: /* @__PURE__ */ d.jsx(
        k,
        {
          ...n,
          max: q,
          min: N,
          size: $,
          style: { width: "100%" },
          disabled: j ?? e.disabled,
          suffix: t === "percentage" ? "%" : x,
          parser: (r) => r.replace(/\$\s?|(,*)/g, ""),
          prefix: t === "currency" ? I : g,
          onStep: (r) => {
            n.onChange(r), i && i(r);
          },
          onChange: (r) => {
            n.onChange(r), i && i(r);
          },
          onFocus: (r) => {
            !e.readOnly && f(!0), a && a(r);
          },
          onBlur: (r) => {
            !e.readOnly && f(!1), n.onBlur(), p && p(r);
          },
          formatter: (r) => E(r) || t === "normal" || C ? `${r}` : O(parseFloat(`${r}`), {
            symbol: "",
            precision: z
          }).format(),
          ...e
        }
      )
    }
  );
};
export {
  V as default
};
